<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>置顶公告</h4>
      </div>
    </div>
    <div class="box-detail">
      <el-table :data="topNotice" >
        <el-table-column label="标题" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" @click.native.prevent="doShow(scope.row, true)">
              {{ scope.row.title }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column property="createTime" label="创建时间"></el-table-column>
        <el-table-column property="createUserName" label="创建人"></el-table-column>
      </el-table>
    </div>
    <div class="head-box"></div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>企业公告</h4>
      </div>
    </div>
    <div class="box-detail">
      <el-table :data="notice" >
        <el-table-column label="标题" fixed="left">
          <template slot-scope="scope">
            <el-button type="text" @click.native.prevent="doShow(scope.row)">
              {{ scope.row.title }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column property="createTime" label="创建时间" ></el-table-column>
        <el-table-column property="createUserName" label="创建人"></el-table-column>
      </el-table>
    </div>

    <el-dialog
        :title='企业公告'
        id="userShowDialog"
        :visible.sync="showDialog"
        width="800px"
    >
      <div class="showCell">
        <span>标题：</span>
        <span>{{ showRow.title }}</span>
      </div>
      <div class="showCell">
        <span>图片：</span>
        <el-image
            style="width: 100px; height: 100px; margin: 5px"
            v-for="(item, index) in showRow.fileList"
            :key="index"
            :src="item.url"
            :preview-src-list="[item.url]"
        ></el-image>
      </div>
      <div class="showCell">
        <span>内容：</span>
        <span v-html="showRow.content"></span>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    window.navData = this;
    window.$this = window.$this || this;
    return {
      topNotice: [],
      notice: [],
      showDialog: false,
      showRow: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 5
      }
    };
  },
  mounted() {
    this.getData(1);
    this.getData();
  },
  methods: {
    getData: function(isTop) {
      var params = {
        'is:type|integer#and': 3,
        'is:isTop|integer#and': isTop || '',
        sortField: 'isTop,updateTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('document/query.do', params, res => {
          if (isTop) {
            //1置顶
            this.topNotice = res.data;
          } else {
            this.notice = res.data;
          }
      });
    },
    //展示信息按钮
    doShow(row) {
      row.exts = row.exts || {};
      if (this.type == '4') {
        row.exts.rate = row.exts.rate ? Number(row.exts.rate) : 0;
      }

      if (row.fileids && row.fileids.length) {
        row.fileList = row.fileids.map(item => {
          item = this.$util.isJson(item) ? JSON.parse(item) : item;
          if (typeof item == 'string') {
            //item格式为 uuid_要展示的名字.文件扩展名，有_取_后面的，没有返回整个
            let showName = item.indexOf('_') != -1 ? item.substr(item.indexOf('_') + 1) : item;
            return {
              url: this.upload.downloadUrl + item.replace(window.$this.osg.downloadUrl, ''),
              name: showName
            };
          } else {
            //item格式为 uuid_要展示的名字.文件扩展名，有_取_后面的，没有返回整个
            let showName =
                typeof item == 'string'
                    ? item.indexOf('_') != -1
                        ? item.substr(item.indexOf('_') + 1)
                        : item
                    : '';
            return {
              url: this.upload.downloadUrl + item.url.replace(window.$this.osg.downloadUrl, ''),
              name: showName
            };
          }
        });
      }
      this.showRow = this.$util.deepCopy(row);
      this.showDialog = true;
    },
  }
};
</script>